import { Component, EventEmitter, Output } from '@angular/core';
import { LocalStorageService } from '../../services';

@Component({
	selector: 'help-center',
	styleUrls: ['./help-center.component.less'],
	templateUrl: './help-center.component.html'
})
export class HelpCenterComponent {
	tabIndex: number = 0;
	constructor(private local: LocalStorageService) {
		const d = this.local.getData('help_center', true);
		if (d)
			this.tabIndex = +d;
	}

	onTabChange = () => {
		this.local.saveData('help_center', this.tabIndex.toString(), true);
	}

}
